<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- Actions header (sticky within scrollable content) -->

        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
          <div class="d-flex justify-content-between align-items-center sticky-top mb-2">

            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>
           <button
              v-can-create.permission="'discussions'"
               class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm ms-auto"
              data-bs-toggle="modal"
              data-bs-target="#create_discussion"
            >
              <span class="small text-xs d-flex align-items-center gap-1">
                Create Discussion
              </span>
            </button>
          </div>


          <div class="row g-2 mb-3">
            <div
              v-for="card in discussion_dashboard_cards"
              :key="card.label"
              class="col-6 col-md-4 col-xl"
            >
              <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                  <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                    <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                    <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                  </div>
                  <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                    <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
                 <div class="d-flex justify-content-end mb-2">
         
          </div>
          <!-- table -->
           <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Discussion List...</p>
            </div>
            <div v-show="!isLoading">
            
          <div v-if="disscussion_topics && disscussion_topics.length > 0" class="table-responsive">
            <table id="discussion-table" class="table align-middle table-striped table-borderless mb-0">
              <thead class="text-uppercase btn-primary text-white ">
                <tr>
                  <th class="text-xxs fw-light">No.</th>
                  <th class="text-xxs fw-light text-center">Discussion Name</th>
                  <th class="text-xxs fw-light text-center">Discussion Description</th>
                  <th class="text-xxs fw-light text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                <!-- Apply text-xxs at the row level for all cells -->
                <tr v-for="(discussion, index) in disscussion_topics" :key="discussion.id" class="border-bottom text-xxs">
                  <!-- Number -->
                  <td class="text-center">
                    <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                      {{ index + 1 }}
                    </span>
                  </td>

                  <!-- Discussion Name -->
                  <td class="text-center">
                    <div class="text-xxs">{{ discussion.name }}</div>
                  </td>

                  <!-- Discussion Description -->
                  <td class="text-center">
                    <div class="text-xxs">{{ discussion.description }}</div>
                  </td>

                  <!-- Actions -->
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <button
                        type="button"
                        class="btn btn-light btn-sm rounded-3 text-primary border"
                        @click="display_comment_modal(discussion)"
                      >
                        <span class="text-xxs">View</span>
                    </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-success border"

                      >
                        <span class="text-xxs">Edit</span>
                      </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-danger border"
                        @click="delete_topic(discussion.id)"
                      >
                        <span class="text-xxs">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else
              class="d-flex flex-column align-items-center justify-content-center text-center py-5 w-100">
              
              <i class="bi bi-clipboard2-data display-1 text-light-emphasis mb-3" aria-hidden="true"></i>
              
              <h5 class="text-muted fw-normal">No discussions found</h5>
              <p class="text-muted small">When you create a new discussion, they will appear here.</p>
          </div>
          </div>
          </div>
        </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->

<teleport to="body">
<div class="modal fade" id="view_discussion_modal" tabindex="-1" aria-labelledby="viewDiscussionLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="viewDiscussionLabel">
          {{ report_data?.name || 'Discussion' }}
        </p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body modal-body-scroll">
        <p v-if="report_data?.description" class="text-muted text-xxs mb-3" v-html="report_data.description"></p>
        <DisscussionComment
          v-if="comment_modal_visible && report_data"
          :discussion="report_data"
          @hide_comment="hide_comment"
        />
      </div>
    </div>
  </div>
</div>

<!-- Create / Edit Discussion Modal -->
<div class="modal fade" id="create_discussion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="exampleModalLabel">
            {{ isEditMode ? 'Edit Discussion' : 'Create a Discussion' }}
          </p>

          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
      </div>
    <form @submit.prevent="create_discussion_topic_context">
      <div class="modal-body">

      <div class="mb-3">
        <label class="form-label text-xxs fw-500">
          Topic name <span class="text-danger">*</span>
        </label>

        <input type="text"
               class="form-control rounded text-xxs"
               placeholder="Enter topic name"
               v-model="topic_name" />

        <p v-if="errors.topic_name" class="text-danger text-xxs mt-1">
          {{ errors.topic_name }}
        </p>
      </div>

      <div class="mb-3">
        <label class="form-label text-xxs fw-500">
          Discussion Description <span class="text-danger">*</span>
        </label>

        <QuillEditor theme="snow"
                     v-model="description"
                     ref="quillDiscussionsEditorRef"
                     class="quill-editor"
                     placeholder="Enter your description here..."
                     toolbar="half" />

        <p v-if="errors.description" class="text-danger text-xxs mt-1">
          {{ errors.description }}
        </p>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <button type="submit"
                class="btn btn-primary btn-sm text-xxs rounded">
          Save
        </button>
      </div>
</div>
    </form>
    </div>
  </div>
</div>

</teleport>
